export default __webpack_public_path__ + "static/media/IWantMom.ec9d6ccf.svg";